import browserStorage from './browserStorage';
import { v4 as uuidv4 } from 'uuid';
import { i18n } from './globalize';

const CоокieCategories = () => {
	return {
		essential: {
			label: i18n.t('FO_CookieCategories_EssentialCookies'),
			description: i18n.t('FO_CookieCategories_EssentialCookies_Description'),
			required: true,
			cookies: [
				{ name: 'accessToken', duration: i18n.t('FO_CookieCategories_AccessToken_Duration'), description: i18n.t('FO_CookieCategories_AccessToken_Description'), enabled: true },
				{ name: 'refreshToken', duration: i18n.t('FO_CookieCategories_RefreshToken_Duration'), description: i18n.t('FO_CookieCategories_RefreshToken_Description'), enabled: true },
				{ name: 'i18n_lng', duration: i18n.t('FO_CookieCategories_Lng_Duration'), description: i18n.t('FO_CookieCategories_Lng_Description'), enabled: true },
				{ name: 'cookieConsent', duration: i18n.t('FO_CookieCategories_CookieConsent_Duration'), description: i18n.t('FO_CookieCategories_CookieConsent_Description'), enabled: true },
				{ name: 'm', duration: i18n.t('FO_CookieCategories_М_Duration'), description: i18n.t('FO_CookieCategories_М_Description'), enabled: true },
				{ name: '__stripe_mid', duration: i18n.t('FO_CookieCategories_StripeMid_Duration'), description: i18n.t('FO_CookieCategories_StripeMid_Description'), enabled: true }
			]
		},
		analytics: {
			label: i18n.t('FO_CookieCategories_AnalyticsCookies'),
			description: i18n.t('FO_CookieCategories_AnalyticsCookies_Description'),
			required: false,
			cookies: [
				{ name: '_ga', duration: i18n.t('FO_CookieCategories_GA_Duration'), description: i18n.t('FO_CookieCategories_GA_Description'), enabled: franchisor => franchisor.enableGoogleAnalytics },
				{ name: '_ga_*', duration: i18n.t('FO_CookieCategories_GA_Duration'), description: i18n.t('FO_CookieCategories_GAStar_Description'), enabled: franchisor => franchisor.enableGoogleAnalytics },
				{ name: 'NRBA_SESSION', duration: i18n.t('FO_CookieCategories_NRBA_SESSION_Duration'), description: i18n.t('FO_CookieCategories_NRBA_SESSION_Description'), enabled: true }
			]
		},
		marketing: {
			label: i18n.t('FO_CookieCategories_MarketingCookies'),
			description: i18n.t('FO_CookieCategories_MarketingCookies_Description'),
			required: false,
			cookies: [
				{ name: 'campaign', duration: i18n.t('FO_CookieCategories_Campaign_Duration'), description: i18n.t('FO_CookieCategories_Campaign_Description'), enabled: true },
				{ name: '_fbp', duration: i18n.t('FO_CookieCategories_Fbp_Duration'), description: i18n.t('FO_CookieCategories_Fbp_Description'), enabled: franchisor => franchisor.trackFacebookPixel },
				{ name: 'lastExternalReferrer', duration: i18n.t('FO_CookieCategories_LastExternalReferrer_Duration'), description: i18n.t('FO_CookieCategories_LastExternalReferrer_Description'), enabled: franchisor => franchisor.trackFacebookPixel },
				{ name: 'lastExternalReferrerTime', duration: i18n.t('FO_CookieCategories_LastExternalReferrerTime_Duration'), description: i18n.t('FO_CookieCategories_LastExternalReferrerTime_Description'), enabled: franchisor => franchisor.trackFacebookPixel },
				{ name: 'topicsLastReferenceTime', duration: i18n.t('FO_CookieCategories_TopicsLastReferenceTime_Duration'), description: i18n.t('FO_CookieCategories_TopicsLastReferenceTime_Description'), enabled: franchisor => franchisor.trackFacebookPixel }
			]
		}
	}
};

const getCookieCategories = (franchisor) => {
	return Object.entries(CоокieCategories()).reduce((acc, [key, category]) => {
		acc[key] = {
			...category,
			cookies: category.cookies.filter(cookie => {
				if (typeof cookie.enabled === 'function') {
					return cookie.enabled(franchisor);
				} else {
					return cookie.enabled !== undefined ? cookie.enabled : true;
				}
			})
		};
		return acc;
	}, {});
}

const getCookieConsent = (franchisor) => {
	const savedCookieConsent = browserStorage.getFromLocalStorage(franchisor, 'cookieConsent');
	const cookieConsent = savedCookieConsent ? JSON.parse(savedCookieConsent) : {
		timestamp: null,
		preferences: { essential: true, analytics: false, marketing: false },
		consentId: uuidv4()
	};
	// If loaded from storage and missing id, add it
	if (!cookieConsent.consentId) {
		cookieConsent.consentId = uuidv4();
	}
	return cookieConsent;
}

const getCookiePreferences = (franchisor) => {
	return getCookieConsent(franchisor).preferences;
};

const saveCookiePreferences = (franchisor, preferences) => {
	// Get existing consent to preserve id if present
	const existing = getCookieConsent(franchisor);

	var cookieConsent = {
		timestamp: new Date(),
		preferences,
		consentId: existing.consentId || uuidv4()
	};
	browserStorage.setToLocalStorage(franchisor, 'cookieConsent', JSON.stringify(cookieConsent));

	// Remove analytics and marketing cookies based on preferences
	if (!preferences.analytics) {
		removeGoogleAnalyticsCookies();
		removeNewRelicCookies();
	}
	if (!preferences.marketing) {
		removeFacebookPixelCookies();
		removeCampaignTags(franchisor);
	}
	window.location.reload();
};

const validateCookieConsent = (franchisor) => {
	const consent = browserStorage.getFromLocalStorage(franchisor, 'cookieConsent');
	if (consent) {
		if (franchisor.renewCookieConsentDate) {

			const consentObj = JSON.parse(consent);
			const consentTimestamp = new Date(consentObj.timestamp);

			const renewDate = new Date(franchisor.renewCookieConsentDate);
			if (consentTimestamp < renewDate) {
				browserStorage.removeFromLocalStorage(franchisor, 'cookieConsent');
				removeAllCookies(franchisor);
			}
		}
	}
	else {
		removeAllCookies(franchisor);
	}
};

const removeFacebookPixelCookies = () => {
	removeCookiesByPrefix('_fbp');
	removeCookiesByPrefix('pys');
}

const removeCampaignTags = (franchisor) => {
	// remove campaign tags from local storage
	browserStorage.removeFromLocalStorage(franchisor, 'campaign');
};

const removeNewRelicCookies = () => {
	localStorage.removeItem('NRBA_SESSION');
}

const removeGoogleAnalyticsCookies = () => {
	removeCookiesByPrefix('_ga');
}

const removeAllCookies = (franchisor) => {
	if (typeof document !== 'undefined') {
		document.cookie.split(';').forEach(cookie => {
			const cookieName = cookie.split('=')[0].trim();
			removeCookie(cookieName);
		});
	}

	const keysToKeep =
		[
			browserStorage.getKeyNameForFranchisor(franchisor, 'i18n_lng'),
			browserStorage.getKeyNameForFranchisor(franchisor, 'accessToken'),
			browserStorage.getKeyNameForFranchisor(franchisor, 'refreshToken')
		];

	Object.keys(localStorage)
		.filter(key => !keysToKeep.includes(key))
		.forEach(key => localStorage.removeItem(key));
}

const removeCookie = (cookieName) => {
	const hostnameParts = window.location.hostname.split('.');
	const domainVariants = [];

	// Build list of domain variants (e.g., app.example.com, .example.com)
	for (let i = 0; i < hostnameParts.length; i++) {
		const domain = hostnameParts.slice(i).join('.');
		domainVariants.push(domain);
		domainVariants.push('.' + domain);
	}

	// remove cookie for all domain variants
	domainVariants.forEach(domain => {
		document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${domain};`;
	});
	// also try without a domain
	document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

const removeCookiesByPrefix = (prefix) => {
	if (typeof document !== 'undefined') {
		document.cookie.split(';').forEach(cookie => {
			const cookieName = cookie.split('=')[0].trim();
			if (cookieName.startsWith(prefix)) {
				removeCookie(cookieName);
			}
		});
	}
};

export default {
	getCookieCategories,
	getCookieConsent,
	getCookiePreferences,
	saveCookiePreferences,
	validateCookieConsent,
	removeFacebookPixelCookies,
	removeGoogleAnalyticsCookies,
	removeCampaignTags,
	removeAllCookies
};
